import { Component } from "react";
import * as React from "react";
import { Product } from "../../api/models/Product";

import { ProductCard } from "./ProductCard";
import "./ProductCarousel.css";

interface IProductCarouselProps {
    products: Product[];
    style?: React.CSSProperties;
}

export class ProductCarousel extends Component<IProductCarouselProps> {
    public render() {
        const products = this.props.products.map((p, i) => {
            return <ProductCard product={p} key={i} />
        })

        return (
            <div className="grid-x grid-margin-x" style={{ marginBottom: "2rem" }}>
                {products}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/product/ProductCarousel.tsx